import { useEffect, useState } from "react";

export default function SocialShare({ title }) {
    const [pageUrl, setPageUrl] = useState("");
    const [pageTitle, setPageTitle] = useState("");

    useEffect(() => {
        setPageUrl(encodeURIComponent(window.location.href));
        setPageTitle(encodeURIComponent(title || document.title));
    }, [title]);

    const open = (url) =>
        window.open(url, "_blank", "noopener,noreferrer");

    if (!pageUrl) return null; // prevent empty popup

    console.log("Rendering SocialShare with URL:", pageUrl, title);

    return (
        <div className="flex flex-wrap items-center gap-3 mt-4">
            <span className="text-sm font-semibold text-gray-700">Share:</span>

            {/* Facebook */}
            <button
                onClick={() =>
                    open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`)
                }
                className="share-btn bg-[#1877F2]"
            >
                Facebook
            </button>

            {/* X / Twitter */}
            <button
                onClick={() =>
                    open(`https://twitter.com/intent/tweet?text=${pageTitle}&url=${pageUrl}`)
                }
                className="share-btn bg-black"
            >
                X
            </button>

            {/* WhatsApp */}
            <button
                onClick={() =>
                    open(`https://wa.me/?text=${pageTitle}%20${pageUrl}`)
                }
                className="share-btn bg-[#25D366]"
            >
                WhatsApp
            </button>

            {/* Copy */}
            <button
                onClick={() => {
                    navigator.clipboard.writeText(window.location.href);
                    alert("Link copied!");
                }}
                className="share-btn bg-gray-600"
            >
                Copy
            </button>
        </div>
    );
}
